function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { DEFAULT_TAX_SPLIT } from '../../../shared/constants/customer.constants';
import { BILLING_EFFECTIVE_DATE_INTENTION, ORDER_EXECUTION_DATE_INTENTION } from '../../../../reducers/constants/wizard.constants';
function getServiceAttributes(attributes, pricingPlanId) {
  var serviceAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  // Get the filtered service attributes, which belongs to the current pricingPlanId
  var filteredAttributes = pricingPlanId ? Object.entries(attributes).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      ServiceAttributeId = _ref2[0];
    return serviceAttributes.find(function (attribute) {
      return +ServiceAttributeId === attribute.ServiceAttributeId && pricingPlanId === attribute.PricingPlanId;
    });
  }) : Object.entries(attributes);
  return filteredAttributes.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      ServiceAttributeId = _ref4[0],
      Value = _ref4[1];
    return {
      ServiceAttributeId: ServiceAttributeId,
      Value: Value
    };
  });
}
export function getFormattedGroupOrderItems(state) {
  var serviceFeatures = [];
  if (state.selectedServiceFeatures && state.selectedServiceFeatures.length) {
    state.selectedServiceFeatures.forEach(function (feature) {
      serviceFeatures.push({
        PricingPlanId: feature.pricingPlanId,
        ProductId: feature.productId,
        ShoppingCartItemBillerRuleDetails: feature.billerRuleDetails,
        ServiceAttributes: []
      });
    });
  }
  var groupOrderItems = (state.shoppingCart.Items || []).reduce(function (acc, _ref5) {
    var OfferingId = _ref5.OfferingId,
      ProductId = _ref5.ProductId,
      PricingPlanId = _ref5.PricingPlanId,
      ShoppingCartItemBillerRuleDetails = _ref5.ShoppingCartItemBillerRuleDetails,
      IsServiceIndependent = _ref5.Details.PricingPlan.IsServiceIndependent;
    if (IsServiceIndependent) {
      acc.serviceIndependentItems.push({
        OfferingId: OfferingId,
        ProductId: ProductId,
        PricingPlanId: PricingPlanId,
        ShoppingCartItemBillerRuleDetails: ShoppingCartItemBillerRuleDetails
      });
    } else {
      if (!acc.serviceTemplates[OfferingId]) {
        acc.serviceTemplates[OfferingId] = {
          OfferingId: OfferingId,
          TemplateShoppingCartItems: serviceFeatures,
          OrderedOfferingAdditionalProperties: state.offerAdditionalProperties,
          Services: []
        };
      }

      // Shopping cart items with group template values for the current PricingPlan
      acc.serviceTemplates[OfferingId].TemplateShoppingCartItems.push({
        ProductId: ProductId,
        PricingPlanId: PricingPlanId,
        ServiceAttributes: getServiceAttributes(state.groupTemplate.attributes, PricingPlanId, state.serviceAttributeFields),
        ShoppingCartItemBillerRuleDetails: ShoppingCartItemBillerRuleDetails
      });

      // All services, with the overridden attributes values
      if (!acc.serviceTemplates[OfferingId].Services.length) {
        acc.serviceTemplates[OfferingId].Services = state.serviceTemplates.map(function (serviceTemplate) {
          return _objectSpread(_objectSpread({}, serviceTemplate.taxLocation ? {
            GroupOrderServiceTaxCustomization: {
              OriginatingNpaNxx: serviceTemplate.taxLocation.OriginatingTaxServiceLocation.NpaNxx,
              OriginatingPercentage: serviceTemplate.taxLocation.OriginatingPercentage || DEFAULT_TAX_SPLIT,
              TerminatingNpaNxx: serviceTemplate.taxLocation.TerminatingTaxServiceLocation.NpaNxx
            }
          } : {}), {}, {
            ServiceAttributes: getServiceAttributes(serviceTemplate.attributes)
          });
        });
      }
    }
    return acc;
  }, {
    serviceIndependentItems: [],
    serviceTemplates: {}
  });
  return {
    AdditionalProperties: state.orderAdditionalProperties,
    OrderedOfferingAdditionalProperties: !!groupOrderItems.serviceIndependentItems.length ? state.offerAdditionalProperties : undefined,
    BillingEffectiveDate: state.executionOptions.billingEffectiveIntention === BILLING_EFFECTIVE_DATE_INTENTION.OnSpecificDate && state.executionOptions.billingEffectiveDate || undefined,
    BillingEffectiveDateIntention: state.executionOptions.billingEffectiveIntention || undefined,
    ExecutionDate: state.executionOptions.effective === ORDER_EXECUTION_DATE_INTENTION.OnSpecificDate && state.executionOptions.specifiedDate || undefined,
    ExecutionDateIntention: state.executionOptions.effective || undefined,
    ServiceIndependentItems: groupOrderItems.serviceIndependentItems,
    ServiceTemplates: Object.values(groupOrderItems.serviceTemplates)
  };
}